import React from "react";
import { Popper } from "@mui/material";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import { useCustomTheme } from "../../style/hooks.js";
const AutocompletePopper = ({ style, ...props }) => {
  const { width, ...otherStyles } = style;
  const theme = useCustomTheme();
  let boxWithBorderWidth = 0;
  try {
    boxWithBorderWidth = Number(width) + theme.custom.borderWidth * 2;
  } catch {
    boxWithBorderWidth = width;
  }
  return /* @__PURE__ */ React.createElement(
    Popper,
    {
      placement: "bottom",
      ...props,
      style: { ...otherStyles, height: 0, width: boxWithBorderWidth },
      popperOptions: {
        modifiers: [
          {
            offset: {
              offset: "0,0"
            }
          }
        ]
      }
    }
  );
};
export {
  AutocompletePopper
};
//# sourceMappingURL=AutocompletePopper.js.map
